export default "__VITE_ASSET__DhlpKBBM__"